module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Prologue.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame-10"
  }, [_c('p', {
    staticClass: "ch"
  }, [_c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  }, [_vm._v("Prologue")])]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("I, Fernanda Elena Maria Sobrano, am tell you this thing from my heart, how I find this man, Hawk Rivera, and ask for his help. My lady she not know what I do, but you will understand when I tell what happen.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph-9"
  })])]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  })]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e064fd9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Prologue.vue
// module id = 81
// module chunks = 0